import React, { useEffect } from 'react';

const ThankYou: React.FC = () => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = 'Yugal Kunj - Thank You';
    }
  }, []);

  return (
    <div style={{
      minHeight: '70vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px'
    }}>
      <img
        src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png"
        alt="Yugal Kunj"
        style={{ width: 120, height: 'auto', marginBottom: 16 }}
      />
      <h1 style={{
        fontSize: '2.25rem',
        margin: 0,
        fontWeight: 700,
        textAlign: 'center'
      }}>
        Thank You!
      </h1>
      <p style={{ marginTop: 12, color: '#555', textAlign: 'center', maxWidth: 680 }}>
        We appreciate your support. A confirmation email has been sent to your inbox.
      </p>
    </div>
  );
};

export default ThankYou;
